import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 16px 20px;
  background: ${colors.white};
  border: 1px solid ${colors.gray300};
  border-left: 4px solid ${colors.orange500};
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.1);
  }
`

export const ProjectInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ProjectPrefix = styled.span`
  font-weight: 600;
  color: ${colors.gray900};
  font-size: 14px;
  white-space: nowrap;
`

export const SelectedValueContainer = styled.div`
  position: relative;
  flex: 1;
`

export const SelectedValueButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: 1px solid ${colors.gray300};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: ${colors.gray900};
  text-align: left;
  min-height: 40px;

  &:hover {
    border-color: ${colors.gray400};
  }

  &:focus {
    outline: none;
    border-color: ${colors.orange500};
    box-shadow: 0 0 0 2px ${colors.orange50};
  }
`

export const SelectedValueText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${colors.gray900};
`

export const SearchDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${colors.white};
  border: 1px solid ${colors.gray300};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid ${colors.gray200};
  background: ${colors.white};
`

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: ${colors.gray900};
  background: transparent;

  &::placeholder {
    color: ${colors.gray500};
  }
`

export const SearchResultsList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  min-height: 50px;
`

export const SearchResultItem = styled.div<{ isSelected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: ${({ isSelected }) =>
    isSelected ? colors.gray50 : 'transparent'};

  &:hover {
    background-color: ${colors.gray100};
  }

  &:first-of-type {
    border-top: none;
  }
`

export const SearchResultText = styled.span`
  flex: 1;
  font-size: 14px;
  color: ${colors.gray900};
`

export const SearchResultCheck = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 8px;
`
